module.exports = __webpack_public_path__ + "img/MuayThaiChampion_MainGame.690d607f.jpg";